import {REQUEST_ORDERS, RECEIVE_ORDERS, REQUEST_ORDER_DATES, RECEIVE_ORDER_DATES} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function ordersReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_ORDERS:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_ORDERS:
      return objectAssign({}, state, {
        orders: action.orders,
        isFetching: false
      });

    case REQUEST_ORDER_DATES:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_ORDER_DATES:
      return objectAssign({}, state, {
        orderDates: action.dates,
        isFetching: false
      });

    default:
      return state;
  }
}
